// src/Science/ScienceWelcomeContent.js

/**
 * Dynamically generates the welcome slide content for Science lessons.
 * Lists chapter titles based on the selected grade.
 */
export function generateScienceWelcomeContent(grade, ScienceLessonPages) {
    const gradeChapters = ScienceLessonPages[grade];
    if (!gradeChapters) {
      return (
        <p>
          Science content for this grade is coming soon!
        </p>
      );
    }
  
    // Extract chapter titles (first slide in each chapter)
    const chapterTitles = Object.values(gradeChapters)
      .map((slides) => slides[0]?.title)
      .filter(Boolean);
  
    return (
      <>
        <p>
          In this lesson, you will learn about:
        </p>
        <ul>
          {chapterTitles.map((title, idx) => (
            <li key={idx}>
              <b>{title}</b>
            </li>
          ))}
        </ul>
        <p>
          Flip through the pages and try the quizzes after each chapter.
        </p>
        <p>
          Let’s get started! <span role="img" aria-label="sparkles">✨</span>
        </p>
      </>
    );
  }
  